import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import PropTypes from "prop-types";
import * as Yup from "yup";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  FontAwesomeIconStyled,
  FormLabelStyled,
  GridAddressContainerStyled,
  GridContactContainerStyled,
  GridItemStyled,
  LinkDeleteStyled,
  TextFieldStyled
} from "./CreateSubEmployerForm.styles";
const CreateSubEmployerForm = (props) => {
  const { employer, subEmployer } = props;
  const intl = useIntl();
  const [employerErrorField, setEmployerErrorField] = useState(null);
  const [employerErrorMessage, setEmployerErrorMessage] = useState(null);
  const [sameAddressAsHolding, setSameAddressAsHolding] = useState(true);
  const [sameContactAsHolding, setSameContactAsHolding] = useState(true);
  const validationSchema = Yup.object().shape({
    employerName: Yup.string().trim().strict().max(255).required(),
    employerEmail: Yup.string().trim().strict().max(255).email(),
    employerPhone: Yup.string().trim().strict().max(255),
    contactName: Yup.string().trim().strict().max(255),
    contactEmail: Yup.string().trim().strict().max(255).email(),
    contactPhone: Yup.string().trim().strict().max(255),
    chamberOfCommerce: Yup.string().trim().strict().max(50),
    sectorCode: Yup.string().trim().strict().max(255),
    payrollTaxNumber: Yup.string().trim().strict().max(50),
    address: Yup.string().trim().strict(),
    zipCode: Yup.string().trim().strict().max(255),
    city: Yup.string().trim().strict().max(255)
  });
  useEffect(() => {
    subEmployer.parentId = employer.employerId;
    subEmployer.address = employer.address;
    subEmployer.zipCode = employer.zipCode;
    subEmployer.city = employer.city;
    subEmployer.contactName = employer.contactName;
    subEmployer.contactEmail = employer.contactEmail;
    subEmployer.contactPhone = employer.contactPhone;
    subEmployer.ownerId = employer.ownerId;
    subEmployer.owner = employer.owner;
  }, [employer, subEmployer]);
  const handleChange = (field) => (event) => {
    subEmployer[field] = event.target.value;
    Yup.reach(validationSchema, field).validate(subEmployer[field]).then(() => {
      setEmployerErrorField(null);
      setEmployerErrorMessage(null);
    }).catch((e) => {
      setEmployerErrorField(field);
      setEmployerErrorMessage(e.message);
    });
  };
  const handleSameAddressAsHoldingChange = (event) => {
    setSameAddressAsHolding(event.target.checked);
    if (!event.target.checked) {
      subEmployer.address = "";
      subEmployer.zipCode = "";
      subEmployer.city = "";
    } else {
      subEmployer.address = employer.address;
      subEmployer.zipCode = employer.zipCode;
      subEmployer.city = employer.city;
    }
  };
  const handleSameContactAsHoldingChange = (event) => {
    setSameContactAsHolding(event.target.checked);
    if (!event.target.checked) {
      subEmployer.contactName = "";
      subEmployer.contactEmail = "";
      subEmployer.contactPhone = "";
    } else {
      subEmployer.contactName = employer.contactName;
      subEmployer.contactEmail = employer.contactEmail;
      subEmployer.contactPhone = employer.contactPhone;
    }
  };
  const handleDelete = (id) => (event) => {
    props.onDelete(id, event);
  };
  return /* @__PURE__ */ React.createElement(Grid, { sx: { width: "100%" }, container: true, spacing: 2 }, /* @__PURE__ */ React.createElement(GridItemStyled, { item: true, xs: 6 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "employers.subEmployerName" })), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      error: employerErrorField === "employerName",
      fullWidth: true,
      helperText: employerErrorField === "employerName" ? employerErrorMessage : null,
      name: "employerName",
      placeholder: intl.formatMessage({ id: "employers.subEmployerName" }).toUpperCase(),
      required: true,
      variant: "outlined",
      onChange: handleChange("employerName")
    }
  )), /* @__PURE__ */ React.createElement(GridItemStyled, { item: true, xs: 6 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "employers.chamberOfCommerce" })), /* @__PURE__ */ React.createElement(
    LinkDeleteStyled,
    {
      disabled: employer.subEmployers.length <= 1,
      href: "#",
      variant: "body1",
      onClick: handleDelete(subEmployer.employerId)
    },
    /* @__PURE__ */ React.createElement(FontAwesomeIconStyled, { icon: faTrash }),
    /* @__PURE__ */ React.createElement(FormattedMessage, { id: "employers.delete" })
  ), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      fullWidth: true,
      name: "chamberOfCommerce",
      placeholder: intl.formatMessage({ id: "employers.chamberOfCommerce" }).toUpperCase(),
      variant: "outlined",
      onChange: handleChange("chamberOfCommerce")
    }
  )), /* @__PURE__ */ React.createElement(GridItemStyled, { item: true, xs: 6 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "employers.sectorCode" })), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      fullWidth: true,
      name: "sectorCode",
      placeholder: intl.formatMessage({ id: "employers.sectorCode" }).toUpperCase(),
      variant: "outlined",
      onChange: handleChange("sectorCode")
    }
  )), /* @__PURE__ */ React.createElement(GridItemStyled, { item: true, xs: 6 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "employers.payrollTaxNumber" })), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      fullWidth: true,
      name: "payrollTaxNumber",
      placeholder: intl.formatMessage({ id: "employers.payrollTaxNumber" }).toUpperCase(),
      variant: "outlined",
      onChange: handleChange("payrollTaxNumber")
    }
  )), /* @__PURE__ */ React.createElement(GridItemStyled, { item: true, xs: 6 }, /* @__PURE__ */ React.createElement(
    FormControlLabel,
    {
      control: /* @__PURE__ */ React.createElement(
        Checkbox,
        {
          color: "secondary",
          sx: { backgroundColor: "transparent" },
          checked: sameAddressAsHolding,
          onChange: handleSameAddressAsHoldingChange
        }
      ),
      label: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "employers.add.subEmployers.sameAddress" })
    }
  )), /* @__PURE__ */ React.createElement(GridItemStyled, { item: true, xs: 6 }, /* @__PURE__ */ React.createElement(
    FormControlLabel,
    {
      control: /* @__PURE__ */ React.createElement(
        Checkbox,
        {
          color: "secondary",
          sx: { backgroundColor: "transparent" },
          checked: sameContactAsHolding,
          onChange: handleSameContactAsHoldingChange
        }
      ),
      label: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "employers.add.subEmployers.sameContact" })
    }
  )), !sameAddressAsHolding && /* @__PURE__ */ React.createElement(GridAddressContainerStyled, { container: true }, /* @__PURE__ */ React.createElement(GridItemStyled, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "employers.address" })), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      fullWidth: true,
      name: "address",
      placeholder: intl.formatMessage({ id: "employers.address" }).toUpperCase(),
      variant: "outlined",
      onChange: handleChange("address")
    }
  )), /* @__PURE__ */ React.createElement(Grid, { container: true, spacing: 2 }, /* @__PURE__ */ React.createElement(GridItemStyled, { item: true, xs: 6 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "employers.zipCode" })), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      fullWidth: true,
      name: "zipCode",
      placeholder: intl.formatMessage({ id: "employers.zipCode" }).toUpperCase(),
      variant: "outlined",
      onChange: handleChange("zipCode")
    }
  )), /* @__PURE__ */ React.createElement(GridItemStyled, { item: true, xs: 6 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "employers.city" })), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      fullWidth: true,
      name: "city",
      placeholder: intl.formatMessage({ id: "employers.city" }).toUpperCase(),
      variant: "outlined",
      onChange: handleChange("city")
    }
  )))), !sameContactAsHolding && /* @__PURE__ */ React.createElement(GridContactContainerStyled, { container: true, spacing: 2 }, /* @__PURE__ */ React.createElement(GridItemStyled, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "employers.contactName" })), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      fullWidth: true,
      name: "contactName",
      placeholder: intl.formatMessage({ id: "employers.contactName" }).toUpperCase(),
      variant: "outlined",
      onChange: handleChange("contactName")
    }
  )), /* @__PURE__ */ React.createElement(GridItemStyled, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "employers.contactEmail" })), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      fullWidth: true,
      name: "contactEmail",
      placeholder: intl.formatMessage({ id: "employers.contactEmail" }).toUpperCase(),
      type: "email",
      variant: "outlined",
      onChange: handleChange("contactEmail")
    }
  )), /* @__PURE__ */ React.createElement(GridItemStyled, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "employers.contactPhone" })), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      fullWidth: true,
      name: "contactPhone",
      placeholder: intl.formatMessage({ id: "employers.contactPhone" }).toUpperCase(),
      variant: "outlined",
      onChange: handleChange("contactPhone")
    }
  ))));
};
CreateSubEmployerForm.propTypes = {
  employer: PropTypes.object,
  subEmployer: PropTypes.object,
  onDelete: PropTypes.func
};
export default CreateSubEmployerForm;
